// Mirrors the backend's MeasureEquivalency.cs. These pairs represent the same real-world
// measure reported under different program numbers (QPP vs CMS eCQM); setting one's answer
// must mirror it to its pair. The server auto-mirrors these too.
export const MEASURE_EQUIVALENCY_PAIRS: ReadonlyArray<readonly [string, string]> = [
  ['QPP-66', 'CMS-146'],
  ['QPP-128', 'CMS-69'],
  ['QPP-130', 'CMS-68'],
  ['QPP-226', 'CMS-138'],
  ['QPP-236', 'CMS-165'],
  ['QPP-238', 'CMS-156'],
  ['QPP-317', 'CMS-22'],
  ['QPP-318', 'CMS-139'],
  ['QPP-374', 'CMS-50'],
];

export function findEquivalentMeasureCode(measureCode: string | null | undefined): string | undefined {
  if (!measureCode) {
    return undefined;
  }

  const matchingPair = MEASURE_EQUIVALENCY_PAIRS.find(
    (pair) => pair[0] === measureCode || pair[1] === measureCode
  );
  if (!matchingPair) {
    return undefined;
  }

  return matchingPair[0] === measureCode ? matchingPair[1] : matchingPair[0];
}
